import {InfoIcon} from '@/assets/icons/icons'
import styled, {css} from 'styled-components'

export const StyledInformCurrentPlan = styled.div<{extraContent: string}>`
    ${({theme: {spacing, palette, typography}}) => css`
        position: relative;
        display: flex;
        padding: ${spacing * 2}px ${spacing}px;
        width: 100%;
        align-items: center;
        gap: ${spacing}px;

        border-radius: 4px;
        border: 0.5px solid #864bd2;
        background: rgba(134, 75, 210, 0.2);
        &:before {
            ${typography.textXxs}
            position: absolute;
            content: ${({extraContent}: {extraContent: string}) => `'${extraContent || ''}'`};
            top: -10px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
            display: flex;
            padding: ${spacing / 2}px ${spacing}px;
            justify-content: center;
            align-items: center;
            gap: ${spacing * 1.25}px;
            border-radius: 4px;
            background: linear-gradient(180deg, #864bd2 0%, #a069e8 100%);
            color: ${palette.neutral.white};
            font-family: Inter;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            white-space: nowrap;
        }
    `}
`
export const StyledInformCurrentPlanColumn = styled.div`
    ${({theme: {spacing}}) => css`
        display: flex;
        flex: 1;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: ${spacing}px;
    `}
`
export const StyledCurrentPlanAmount = styled.div`
    ${({theme: {palette, spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing}px;
        color: ${palette.neutral.black};
        font-family: Inter;
        font-size: 26px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: -1.3px;
        & svg {
            height: 31px;
            width: 31px;
        }
    `}
`
export const StyledCurrentPlanDescription = styled.div`
    ${({theme: {spacing, palette}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 1.5}px;
        color: ${palette.primary[900]};
        text-align: center;
        font-family: Inter;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 19.6px */
        & svg {
            width: 20px;
            height: 20px;
        }
        & > div {
            display: flex;
            gap: ${spacing}px;
        }
    `}
`

export const StyledCurrentPlanCount = styled.div`
    ${({theme: {palette}}) => css`
        color: ${palette.primary[900]};
        text-align: right;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%; /* 19.6px */
    `}
`
export const StyledInfoIcon = styled(InfoIcon)`
    ${({theme: {spacing}}) => css`
        position: absolute;
        cursor: pointer;
        right: ${spacing * 0.75}px;
        top: ${spacing}px;
        width: 15px;
        height: 15px;
    `}
`
